import { Navigate, useParams } from 'react-router-dom';

export default function TermometroPage() {
  const { telaId } = useParams<{ telaId: string }>();
  if (!telaId) return null;
  return <Navigate to={`/jukebox/${telaId}/jogo`} replace />;
}
